import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../../lib/api";
import { NewPill } from "../../../components/NewPill";
import { fmtDateTime } from "../../../components/rx/rxShared";

/** Monitored (prescribed here) versus Outside (pre-visit or other prescriber) medication tabs. */
export function MedSourceTabs({ tab, setTab, counts }) {
  const tabs = [["monitored", "Monitored medications"], ["outside", "Outside medications"]];
  return (
    <div className="inline-flex items-center gap-1 rounded-full bg-[#F1EEE7] p-1" data-testid="med-source-tabs">
      {tabs.map(([k, label]) => (
        <button key={k} type="button" data-testid={`med-source-${k}`} onClick={() => setTab(k)}
          className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-bold transition-colors ${tab === k ? "bg-[#4E342E] text-white" : "text-[#6D4C41] hover:text-[#3E2723]"}`}>
          {label} <span className={`rounded-full px-1.5 text-[10px] ${tab === k ? "bg-white/20" : "bg-white"}`}>{counts[k]}</span>
          {k === "outside" && <NewPill feature="outside-meds" />}
        </button>
      ))}
    </div>
  );
}

/** Attest that the client takes no current medications. Blocked while any medication is active or on hold. */
export function NoCurrentMeds({ client, currentCount, editable, reloadKey }) {
  const [rec, setRec] = useState({ value: false });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/clients/${client.id}/no-current-medications`).then((r) => setRec(r.data)).catch(() => {}); }, [client.id, reloadKey]);
  const toggle = async (value) => {
    setBusy(true);
    try { const r = await api.put(`/clients/${client.id}/no-current-medications`, { value }); setRec(r.data); toast.success(value ? "No current medications recorded" : "No current medications cleared"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const blocked = currentCount > 0 && !rec.value;
  return (
    <label className={`flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs ${rec.value ? "border-[#A5D6A7] bg-[#E8F5E9] text-[#2E7D32]" : "border-[#E5DFD3] bg-white text-[#5D4037]"}`}
      title={blocked ? "Discontinue or complete every active medication first" : undefined} data-testid="no-current-meds">
      <input type="checkbox" data-testid="no-current-meds-check" checked={!!rec.value} disabled={!editable || busy || blocked} onChange={(e) => toggle(e.target.checked)} className="h-4 w-4 accent-[#2E7D32]" />
      <span className="font-semibold">No current medications</span><NewPill feature="no-current-meds" />
      {rec.value && <span className="text-[10px] text-[#33691E]" data-testid="no-current-meds-by">by {rec.by}, {fmtDateTime(rec.at)}</span>}
    </label>
  );
}
